import React from "react";

type Props = {};

const Section57Hint: React.FC<Props> = (props: Props) => {
  return (
    <>
      <p className="leading-para text-greyDark text-start">
        As a taxpayer, you can claim deductions on certain expenses related to 'income from other
        sources'. Common deductions include:
      </p>
      <ol className="text-start text-greyDark leading-para">
        <li>Expenses to earn other income (excluding personal expenses or capital expenditure)</li>
        <li>Expenditure on repairs of rental properties</li>
        <li>Interest paid on loans for investments generating dividends</li>
        <li>Interest on compensation</li>
      </ol>
    </>
  );
};

export default Section57Hint;
